import TableList from 'components/commons/TableList/TableList.component';
import { Stack } from 'styles';
import { ClaimsBody } from './ClaimsBody.component';
import ClaimsHeader from './ClaimsHeader.component';

const Claims = () => {
	return (
		<Stack width={'100%'} height={`calc(100vh - 280px)`} overflow={'hidden'}>
			<TableList header={<ClaimsHeader />} body={<ClaimsBody />} />
		</Stack>
	);
};

export default Claims;
